import { useState, FC, useEffect } from "react";
import dayjs from "dayjs";
import "./CustomDatePicker.css";
import DayView from "./DayView";

interface WeekViewProps {
  visibleDates: dayjs.Dayjs[];
  onDateSelect?: (date: dayjs.Dayjs) => void;
  selectedDate?: dayjs.Dayjs;
}

const WeekView: FC<WeekViewProps> = ({
  visibleDates,
  onDateSelect,
  selectedDate: propSelectedDate,
}) => {
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs>(
    propSelectedDate || dayjs()
  );

  useEffect(() => {
    if (propSelectedDate) {
      setSelectedDate(propSelectedDate);
    }
  }, [propSelectedDate]);

  const onDateClick = (date: dayjs.Dayjs) => {
    setSelectedDate(date);
    if (onDateSelect) {
      onDateSelect(date);
    }
  };

  return (
    <div className="cb-date-list">
      <div className="cb-month-container">
        <div className="cb-days-container">
          {visibleDates.map((date) => (
            <DayView
              key={date.format("YYYY-MM-DD")}
              current={date}
              onDateClick={onDateClick}
              selectedDate={selectedDate}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeekView;
